import Vue from "vue";
import VeeValidate from "vee-validate";
import VueI18n from "vue-i18n";

import App from "@/App";
import router from "@/router";
import store from "@/store";
import messages from "@/lang/";

// Plugins
import Util from "@/lib/util";
import Filter from "@/lib/filter";
import Message from "@/lib/message";
import Modal from "@/lib/modal";
import Service from "@/lib/service";

import Storage from "@/lib/storage";
import Loading from "@/components/plugins/loading/loading";
import serviceOidc from "@/lib/service.oidc";

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
// i18n config
Vue.component("v-select", vSelect);
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "es",
  messages
});

Vue.use(Storage, { appName: "legalizacion-web" });
Vue.use(VeeValidate);
Vue.use(Util);
Vue.use(Filter);
Vue.use(Message);
Vue.use(Modal);
Vue.use(Loading);

Vue.use(Service, {
  apiUrl: process.env.API_URL
});

Vue.use(serviceOidc, {
  Issuer: process.env.OIDC_ISSUER,
  ClientId: process.env.OIDC_CLIENT_ID,
  ClientSecret: process.env.OIDC_CLIENT_SECRET,
  Scope: process.env.OIDC_SCOPE,
  RedirectUri: process.env.OIDC_REDIRECT_URI,
  PostLogoutRedirectUri: process.env.OIDC_POST_LOGOUT_REDIRECT_URI,
  ResponseType: process.env.ODIC_RESPONSE_TYPE
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  store,
  template: "<App/>",
  serviceOidc,
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js